import React from 'react'

const Loader = () => {
    return <div className="loading"/>;
}

export default Loader;